import { useState } from 'react';
import { Section } from '../ui';
import { EMAIL, LINKEDIN } from '../content';

const EMPTY = { firstName: '', lastName: '', email: '', phone: '', message: '' };

export default function Contact() {
  const [form, setForm] = useState(EMPTY);
  const [status, setStatus] = useState('idle'); // idle | sending | sent | error

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  async function onSubmit(e) {
    e.preventDefault();
    setStatus('sending');
    try {
      const res = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      setForm(EMPTY);
      setStatus('sent');
    } catch {
      setStatus('error');
    }
  }

  return (
    <main>
      <Section lg>
        <div className="split" style={{ alignItems: 'start' }}>
          <div>
            <span className="eyebrow">Contact</span>
            <h1 className="h-page" style={{ fontSize: 'clamp(34px, 4.6vw, 58px)', maxWidth: '18ch' }}>
              Let&rsquo;s talk about your operation.
            </h1>
            <p className="lede" style={{ maxWidth: '46ch', marginBottom: 32 }}>
              Whether you&rsquo;re planning a drone operation, developing an inspection program, or
              looking to turn complex visual data into actionable information — we&rsquo;d like to
              hear about it.
            </p>

            <div className="contact-block" style={{ marginTop: 0 }}>
              <div className="ftr__h">Email</div>
              <a href={`mailto:${EMAIL}`} style={{ display: 'inline-block', marginTop: 8, fontSize: 15, color: 'var(--accent)' }}>
                {EMAIL}
              </a>
            </div>
            <div className="contact-block">
              <div className="ftr__h">Follow</div>
              <a
                href={LINKEDIN}
                target="_blank"
                rel="noreferrer"
                style={{ display: 'inline-block', marginTop: 8, fontSize: 15 }}
              >
                LinkedIn &#8599;
              </a>
            </div>
          </div>

          <form className="form" onSubmit={onSubmit}>
            <div className="form__row">
              <label className="field">
                <span>First name *</span>
                <input type="text" required value={form.firstName} onChange={set('firstName')} autoComplete="given-name" />
              </label>
              <label className="field">
                <span>Last name *</span>
                <input type="text" required value={form.lastName} onChange={set('lastName')} autoComplete="family-name" />
              </label>
            </div>
            <div className="form__row">
              <label className="field">
                <span>Email *</span>
                <input type="email" required value={form.email} onChange={set('email')} autoComplete="email" />
              </label>
              <label className="field">
                <span>Phone</span>
                <input type="tel" value={form.phone} onChange={set('phone')} autoComplete="tel" />
              </label>
            </div>
            <label className="field">
              <span>Message</span>
              <textarea rows="5" value={form.message} onChange={set('message')} />
            </label>

            <button className="btn btn--primary" type="submit" disabled={status === 'sending'} style={{ justifySelf: 'start' }}>
              {status === 'sending' ? 'Sending…' : 'Start a conversation'}
            </button>

            {status === 'sent' && (
              <p className="form__note form__note--ok">Thanks — we&rsquo;ll be in touch.</p>
            )}
            {status === 'error' && (
              <p className="form__note form__note--err">
                That didn&rsquo;t go through. Email us directly at{' '}
                <a href={`mailto:${EMAIL}`} style={{ color: 'inherit', textDecoration: 'underline' }}>
                  {EMAIL}
                </a>
                .
              </p>
            )}
          </form>
        </div>
      </Section>
    </main>
  );
}
